export default __webpack_public_path__ + "static/media/new_icon_chat.367432b3.svg";